import React from 'react'
import ModalYesNo from './ModalYesNo'

export default function DeleteTravelListModal() {
  return (
    <ModalYesNo>
      Удалить Путевой лист?
    </ModalYesNo>
  )
}